import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./login/login.component";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { ReactiveFormsModule } from "@angular/forms";
import { ValidatePermissionPipe } from "../pipes/validate-permission/validate-permission.pipe";
import { PlaceComponent } from "./place/place.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@NgModule({
  declarations: [
    LoginComponent,
    PasswordResetComponent,
    ValidatePermissionPipe,
    PlaceComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    MatNativeDateModule,
    MatProgressBarModule,
  ],
  exports: [ValidatePermissionPipe],
})
export class AuthModule {}
